// A phone (STAGE_7, the mobile layout): narrower than 700 px. The admin shell and the
// reports lay themselves out for it; everything else only has to fit.

import { useSyncExternalStore } from 'react';

export const MOBILE_QUERY = '(max-width: 699px)';

function subscribe(onChange: () => void): () => void {
  const query = window.matchMedia(MOBILE_QUERY);
  query.addEventListener('change', onChange);
  return () => {
    query.removeEventListener('change', onChange);
  };
}

function snapshot(): boolean {
  return window.matchMedia(MOBILE_QUERY).matches;
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
